// Warning: Do not edit this file manually!
// It is generated new when you run `npm run build|dev` from the project root
import Icons67f4f85e82bae from '../components/page/icons';
import ProductTile67f4f85e82bb4 from '../components/catalog/product/tile';
import CookieOverlay67f4f85e82bb7 from '../components/cartware_gdpr/cookie-overlay';
import Configurator67f4f85e82bbc from '../components/catalog/product/configurator';

export default {
  default: [
    new Icons67f4f85e82bae(),

    new ProductTile67f4f85e82bb4(),

    new CookieOverlay67f4f85e82bb7(),
  ],
  ab_cropper: [
    new Configurator67f4f85e82bbc(),
  ],
};
